import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.goldfoxmarket.com/api/v1/reward"; // Update with your actual backend URL

// Fetch transactions with filters and pagination
export const fetchTransactions = createAsyncThunk(
  "transactions/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, limit = 10, ...filters } = params ?? {}; // Ensure params is always an object

      // Build query params
      const queryParams = new URLSearchParams({ page, limit });

      // Add all filters to query params
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      });

      const response = await axios.get(`${BASE_URL}/transactions?${queryParams}`);
      console.log(response.data);

      return {
        transactions: response.data.transactions,
        pagination: response.data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch transactions for a specific user with filters
export const fetchUserTransactions = createAsyncThunk(
  "transactions/fetchByUser",
  async ({ userId, ...params }, { rejectWithValue }) => {
    try {
      const { page = 1, limit = 10, ...filters } = params;
      
      // Build query params
      const queryParams = new URLSearchParams();
      queryParams.append('user_id', userId);
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      
      // Add all filters to query params
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          queryParams.append(key, value);
        }
      });
      
      const response = await axios.get(`${BASE_URL}/transactions?${queryParams}`);
      return {
        transactions: response.data.transactions,
        pagination: response.data.pagination
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const transactionSlice = createSlice({
  name: "transactions",
  initialState: {
    transactions: [],
    userTransactions: [],
    pagination: {
      total: 0,
      per_page: 10,
      current_page: 1,
      last_page: 1,
      from: 0,
      to: 0
    },
    userPagination: {
      total: 0,
      per_page: 10,
      current_page: 1,
      last_page: 1,
      from: 0,
      to: 0
    },
    loading: false,
    error: null,
    filters: {
      offer_id: '',
      status: '',
      offer_title: '',
      date_from: '',
      date_to: '',
      amount_min: '',
      amount_max: ''
    }
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = {
        offer_id: '',
        status: '',
        offer_title: '',
        date_from: '',
        date_to: '',
        amount_min: '',
        amount_max: ''
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch all transactions
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.transactions;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Fetch user transactions
      .addCase(fetchUserTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.userTransactions = action.payload.transactions;
        state.userPagination = action.payload.pagination;
      })
      .addCase(fetchUserTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters, resetFilters } = transactionSlice.actions;
export default transactionSlice.reducer;